import cx from 'classnames';

import { NumberInput } from '@flipster/ui';
import { UsdtCurrency, UsdtPrecision } from '@flipster/utils/constants/currency';

import { OrderType } from '../../spot/bunja/form';
import styles from './index.module.scss';

interface Props {
  currency?: string;
  tradeQtyPrecision: number;
  focusTarget: OrderType;
  onChangeFocus: (val: OrderType) => unknown;
  onChangeQtyInput: (val: string) => unknown;
  onChangeAmountInput: (val: string) => unknown;
  qtyValue: string;
  amountValue: string;
}

const OrderAmountInput = ({
  currency,
  tradeQtyPrecision,
  focusTarget,
  onChangeFocus,
  onChangeQtyInput,
  onChangeAmountInput,
  qtyValue,
  amountValue,
}: Props) => {
  return (
    <div className={styles.wrapper}>
      <NumberInput
        shape='inner'
        name='quantity'
        min={0}
        value={qtyValue}
        suffix={
          <span className={styles.currency} translate='no'>
            {currency}
          </span>
        }
        precision={tradeQtyPrecision ?? 2}
        className={cx(styles.input, styles.baseCurrency, { [styles.focused]: focusTarget === 'quantity' })}
        onChange={onChangeQtyInput}
        onFocus={() => onChangeFocus('quantity')}
      />
      <div className={styles.divider} />
      <NumberInput
        shape='inner'
        name='amount'
        min={0}
        value={amountValue}
        suffix={
          <span className={styles.currency} translate='no'>
            {UsdtCurrency}
          </span>
        }
        precision={UsdtPrecision}
        className={cx(styles.input, styles.usdt, { [styles.focused]: focusTarget === 'amount' })}
        onChange={onChangeAmountInput}
        onFocus={() => onChangeFocus('amount')}
      />
    </div>
  );
};

export default OrderAmountInput;
